module.exports = __webpack_public_path__ + "static/media/initial_concept_for_distillery_mural_letterhead_2018.a39cbcb2.webp";